import { configureStore } from "@reduxjs/toolkit"
import allReducer from "./slices"
import axios from "axios"

// Get server region from environment
// Vite uses import.meta.env, Next.js uses process.env
const getServerRegion = () => {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env.VITE_SERVER_REGION
  }
  if (typeof process !== 'undefined' && process.env) {
    return process.env.NEXT_PUBLIC_SERVER_REGION
  }
  return 'GLOBAL'
}

const SERVER_REGION = getServerRegion()

// Debug logging
console.log('🌍 SERVER_REGION detected:', SERVER_REGION)
console.log('🔧 import.meta.env.VITE_SERVER_REGION:', import.meta?.env?.VITE_SERVER_REGION)

// Set axios base URL based on region
axios.defaults.baseURL = SERVER_REGION === 'CN'
  ? "https://api.aivisionfood.cn"
  : "https://api.aivisionfood.com"

console.log('🌐 Axios baseURL set to:', axios.defaults.baseURL)

export const store = configureStore({
  reducer: allReducer,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
